import _ from 'lodash'

export default function getFilteredEventsForLocations(events, activeLocations) {
  return _.filter(events, (event) => _.includes(activeLocations, event?.location))
}